import { lazy, Suspense } from "react";

import { RenderLoadingSpinnerInImageTag } from "../../Helper";
import { useDispatch, useSelector } from "react-redux";
import ChangePassword from "./Modal/ChangePassword";
import { useEffect } from "react";

// * import method different because its a lazy load import
const ComponentHeader = lazy(() => import(`./ComponentHeader`));
const ChangeEmailId = lazy(() => import(`./Modal/ChangeEmailId`));
// const ChangeApiKeyComponent = lazy(() =>
//   import("./Components/ChangeApiKeyComponent")
// );
const LoggedInDeviceInfo = lazy(() =>
  import("./Components/LoggedInDeviceInfo")
);

export default function Settings() {
  // * Start ***Enable Dark Mode Feature***
  const darkModeState = useSelector((state) => state.setMode).darkMode;
  const textColorDynamic = useSelector((state) => state.setMode).css?.textColor;

  const dispatch = useDispatch();

  // * Get user info from redux store [All (data fetch & set in redux) in profile.jsx]
  const userEmailId =
    useSelector((state) => state.user)?.profile_Info?.email ||
    "Fetching Email id..";
  const userApiKey =
    useSelector((state) => state.user)?.profile_Info?.api_Key ||
    "Fetching Api key..";

  useEffect(() => {}, [userApiKey, dispatch]);

  // * Return Component with lazy setup
  function returnComponentWithLazySetup(Component, loadingMsg, component_Key) {
    return (
      <Suspense
        key={component_Key}
        fallback={RenderLoadingSpinnerInImageTag("w-20", "h-20", loadingMsg)}
      >
        {Component}
      </Suspense>
    );
  }

  return (
    <>
      {/* Profile settings */}
      <section className={` my-16`}>
        {returnComponentWithLazySetup(
          <ComponentHeader
            title="Profile settings"
            details="Access your jsonOnClouds account Settings"
          />,
          " Profile settings Lodging.."
        )}
        <section className={` flex flex-wrap justify-center items-center `}>
          <div
            className={` basis-full md:basis-2/3 lg:basis-2/4 xl:basis-2/5 flex flex-wrap`}
          >
            {/* Settings */}
            <div className={` basis-full p-4`}>
              <div
                className={` relative py-9 px-5 space-y-6 shadow-xl rounded-3xl border overflow-hidden ${
                  darkModeState
                    ? " bg-[#001e2b] border-[#38b982] "
                    : " bg-white border-[#38b9813b]"
                }`}
              >
                <h4
                  className={` text-xl lg:text-2xl font-bold font-mono ${textColorDynamic}`}
                >
                  Account
                </h4>

                {/* Api key */}
                {/* {returnComponentWithLazySetup(
                  <ChangeApiKeyComponent apiKey={userApiKey} />,
                  "Change Api key section loading.."
                )} */}

                {/* Change Password */}
                <div className={` space-y-3`}>
                  <h3
                    className={` text-base lg:text-lg font-bold font-mono ${textColorDynamic}`}
                  >
                    Password
                  </h3>
                  {returnComponentWithLazySetup(
                    <ChangePassword
                      uiBtn={
                        <button
                          className={` flex flex-wrap justify-center items-center text-sm font-bold font-mono bg-[#f9fbfa]  py-2 px-3 space-x-2 text-[#102c38] border border-[#102c38] rounded-lg shadow-inner hover:scale-90 ease-in-out duration-300 `}
                        >
                          <i className="ri-key-fill text-lg"></i>
                          <h4>Change your Password?</h4>
                        </button>
                      }
                      modalHeading="Change Your Password Now!"
                    />,
                    "Loading modal Please wait"
                  )}
                </div>

                {/* Update  Email */}
                <div className={` space-y-3`}>
                  <h3
                    className={` text-base lg:text-lg font-bold font-mono ${textColorDynamic}`}
                  >
                    Email
                  </h3>
                  <input
                    disabled={true}
                    value={userEmailId}
                    type="text"
                    name="apiKey"
                    className={` w-full py-[7px] px-2 font-semibold text-[#102c38] rounded-lg border border-black/20 focus:outline-none focus:border-blue-400  focus:border-4  shadow-inner ease-in-out duration-100 cursor-not-allowed select-none  ${
                      darkModeState
                        ? " bg-white/95 opacity-70 "
                        : " bg-black/5 opacity-50 "
                    }`}
                  />
                  {returnComponentWithLazySetup(
                    <ChangeEmailId
                      uiBtn={
                        <button
                          className={` flex flex-wrap justify-center items-center text-sm font-bold font-mono bg-[#f9fbfa]  py-2 px-3 space-x-2 text-[#102c38] border border-[#102c38] rounded-lg shadow-inner hover:scale-90 ease-in-out duration-300 `}
                        >
                          <i className="ri-mail-close-fill text-lg"></i>
                          <h4>Change your Email address?</h4>
                        </button>
                      }
                      modalHeading="Update Your Email Address"
                    />,
                    "Loading modal Please wait"
                  )}
                </div>

                {/* Logged-In device info */}
                {returnComponentWithLazySetup(
                  <LoggedInDeviceInfo />,
                  "Logged-in device info Loading.."
                )}
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
}
